import { ProjectPage } from "../pages/ProjectPage";
import "./footer.css";


 
export const Popup=({darkMode, setDarkMode, setPopup,  title }) =>{
    return (
      <div
        className={`fixed flex items-center justify-center  w-screen h-screen top-0 left-0  z-20 
         `}
      >
        <div
          onClick={() => setPopup(null)}
          className={` absolute    opacity-85  w-full h-full   ${
            darkMode ? "bg-[#181a1b] text-white " : "bg-white text-black"
          }`}
        ></div>
        <div
          className={` relative   h-full md:w-4/5 md:h-4/5 rounded-lg z-20  border-2  overflow-y-auto
                ${darkMode ? "bg-[#181a1b] " : "bg-white"}`}
        >
          <div className="flex justify-between md:justify-end items-center p-4">
            <p className="  md:hidden text-2xl xl:text-3xl   font-extrabold ">Y.Ichiba </p>
            <button
              onClick={() => setPopup(null)}
              className={` absolute h-fit w-fit right-5   z-50 hover:underline  
              ${darkMode ? " text-white" : " text-black"}`}
            >
              &lt; BACK
            </button>
          </div>
          <ProjectPage
            darkMode={darkMode}
            setDarkMode={setDarkMode}
            title={title}
          />
        </div>
      </div>
    );
}